import moment from 'moment';

export default (v) => {
    return (v) ? moment(v).format('DD/MM/YY') : '';
}



// WEBPACK FOOTER //
// ./resources/assets/js/filters/fecha.js